import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=3a21de4a&scoped=true&"
import script from "./fields.vue?vue&type=script&lang=js&"
export * from "./fields.vue?vue&type=script&lang=js&"
import style0 from "./fields.vue?vue&type=style&index=0&id=3a21de4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21de4a",
  null
  
)

export default component.exports